import { Box, Image, Text } from '@bonanza-social/moonlight';

function MissingReferrerPromo() {
  return (
    <Box flex={1} flexDirection="column">
      <Image
        name="inviteFriends.CheckBackSoon"
        borderTopLeftRadius="radius-400"
        borderTopRightRadius="radius-400"
        width="100%"
        aspectRatio={2}
        contentFit="cover"
      />
      <Text
        variant="h5"
        gradient="darkSurfaceAccent"
        locNS="inviteFriends"
        locKey="no_promo_title"
      />
      <Text
        variant="body-m"
        color="darkSurfacePrimary"
        marginTop="space-300"
        locNS="inviteFriends"
        locKey="no_promo_desc"
      />
    </Box>
  );
}

export default MissingReferrerPromo;
